<template>
    <div id="new">
        <!-- ERROR MESSAGES LIST -->
        <div class="ui red icon message" v-if="errors.length > 0">
            <i class="warning icon"></i>
            <div class="content">
                <div class="header">
                    <!-- 請處理以下錯誤 -->
                    {{ $t('ui.notifications.error.please_handle_errors') }}
                </div>
                <p v-for="(error, index) in errors">{{index + 1}}. {{error}}</p>
            </div>
        </div>
        <div class="contents">
            <div class="ui form" :class="{'loading': is_processing}">
                <div class="field">
                    <label>{{ $t('models.attributes.permission_groups.name') }}</label>
                    <input type="text" class="name" v-model="current_data.name">
                </div>

                <div is="PermissionsTable" class="field">
                </div>

                <div class="ui basic positive button" @click="create">
                    {{ $t('ui.general.submit') }}
                </div>
                <router-link :to="{name: 'permission_groups'}" class="ui basic button">
                    <i class="undo icon"></i>
                    {{ $t('ui.general.back') }}
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
import PermissionsTable from './permissions_table.vue'

export default {
    name: "NewPermissionGroup",
    data: function () {
        return {
            show_permission_groups: false,
            is_processing: false,
            errors: [],
        }
    },
    mounted: function() {
        var that = this;

        that.$store.state.provider.permission_groups_module.current_data = "";
    },
    computed: {
        current_data: function() {
            return this.$store.state.provider.permission_groups_module.current_data;
        },
    },
    methods: {
        create: function() {
            var that = this;
            var url = that.$store.state.provider.routes.api_v1_provider_permission_group_create;

            that.errors = [];
            that.is_processing = true;
            axios.post(url, {
                permission_group: that.current_data
            }, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        that.$bus.$emit('init');
                        // that.$noty.success('建立permission_group成功');
                        that.$noty.success(
                            that.$t('ui.notifications.success.create__name', {
                                name: that.$t('models.permission_groups')
                            })
                        );
                        that.$router.push({name: 'permission_groups'});
                    } else {
                        // that.$noty.error('無法建立permission_group');
                        that.$noty.error(
                            that.$t('ui.notifications.error.create__name', {
                                name: that.$t('models.permission_groups')
                            })
                        );
                    }
                    that.is_processing = false;
                })
                .catch(function (error) {
                    // that.$noty.error('建立permission_group失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.create__name', {
                            name: that.$t('models.permission_groups')
                        })
                    );
                    that.is_processing = false;
                });
        }
    },
    components: {
        PermissionsTable,
    }
}
</script>
